var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg7Th(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.88852 3.54L4.56852 16H1.72852L7.08852 3.86H0.248515V1.46H9.88852V3.54ZM13.2895 3.732V6.948C13.2895 7.172 13.3415 7.336 13.4455 7.44C13.5575 7.536 13.7415 7.584 13.9975 7.584H14.7775V9H13.7215C12.3055 9 11.5975 8.312 11.5975 6.936V3.732H10.8055V2.352H11.5975V0.707999H13.2895V2.352H14.7775V3.732H13.2895ZM20.0899 2.256C20.5939 2.256 21.0419 2.368 21.4339 2.592C21.8259 2.808 22.1299 3.132 22.3459 3.564C22.5699 3.988 22.6819 4.5 22.6819 5.1V9H21.0019V5.328C21.0019 4.8 20.8699 4.396 20.6059 4.116C20.3419 3.828 19.9819 3.684 19.5259 3.684C19.0619 3.684 18.6939 3.828 18.4219 4.116C18.1579 4.396 18.0259 4.8 18.0259 5.328V9H16.3459V0.12H18.0259V3.18C18.2419 2.892 18.5299 2.668 18.8899 2.508C19.2499 2.34 19.6499 2.256 20.0899 2.256Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg7Th);
export default __webpack_public_path__ + "static/media/7th.9d309d3dc16656ffba411c954e613163.svg";
export { ForwardRef as ReactComponent };